module.exports = __webpack_public_path__ + "img/sort.4cc473bf.png";